import React from 'react';
// import Skills from './Skills.js';
// import Tilt from 'react-parallax-tilt';
// import Lottie from "lottie-react"
// import Coder from '../LottieFiles/coder.json';

import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import studentsImage from '../assets/racl_students.png';

const About = () => {
  return (
        <>
        <Box height={100} />

            <Grid container spacing={0} alignItems="center" justify="center">
                <Grid item xs={2} />
                <Grid item xs={8}>
                    <Card>
                    <CardHeader title='About Our School'/>
                    <CardContent>
                        <Box textAlign={'left'}>
                            <Typography>
                              三角区中文学校，Triangle Chinese Language School（TriCLS），前身为Raleigh Academy of Chinese Language（RACL），成立于1995年，是一家注册的501(c)(3)非营利教育机构。三十多年来，TriCLS始终服务于北卡罗来纳州研究三角园区（Research Triangle Park）及周边社区，为家庭提供高质量的中文教育，弘扬中华文化，并通过丰富多元的教育项目促进学生的全面发展。
                            </Typography>
                            <br />
                            <Typography>
                              洛丽汉语学校开设学前班至九年级的语文课，本校采用由侨外办委托暨南大学专门为海外华语教学编写的《中文》教材。该教材体系知识面宽，生动活泼，贴近生活，并配有多媒体光盘，为使学生们在学习中国语言的同时有机会接触中国文化的精华，教务组以暨南大学的中国历史/地理/文化配套教材为蓝本，为高年级增设了中国历史/地理/文化单元课，并采用穿插音像辅助教学的方式，使语言教学生动化，形象化，趣味化。
                            </Typography>
                              <br />
                            <Typography>
                              本校还面向有兴趣学习汉语，了解中国文化，中文为第二语言的朋友们，开设了成人CSL (Chinese as a Second Language)中文班和幼儿CSL中文班。
                            </Typography>
                              <br />
                            <Typography>
                              为了丰富学生们及家长们的文化生活，学校设有课外活动班，包括有儿童舞蹈，绘画，围棋，国际象棋，趣味数学，数学SAT，足球，排球，英文写作，英文SAT，太极拳等。
                            </Typography>
                              <br />
                            <Typography>
                              洛丽汉语学校拥有良好的师资。绝大部分老师毕业于师范院校，或拥有其他高等教育的学位。大部分老师有着在国内教授语文，及在海外教授华裔子女中文的丰富经验。教师的斟选实行公开招聘，择优录取。学校把提高教与学的质量，诱导学习兴趣，培养双语人材作为其中心工作环节。
                            </Typography>
                              <br />
                            <Typography>
                              洛丽汉语学校的行政管理机构为校执行委员会。家长会担负着协助校执行委员会，组织家长义务服务的重要任务。学校董事会监督，辅助校执行委员会的日常工作，并规划学校的长远建设。以上三个机构均由学生家长组成，他们全部是义务工作者。
                            </Typography>
                              <br />
                            <Typography>
                              学校的上课时间为每周六上午。语言班：9:15am-11:00am，课外活动班：11:10am-1:00pm。学校日程安排与Wake County公立学校系统配套。语言班共有五百多学生注册，课外活动班约有三百多名学生。洛丽汉语学校热情欢迎三角地区的华裔子女及中文爱好者入学及光临。
                            </Typography>
                              <br />
                            <Typography>
                              洛丽汉语学校的校址位于 Apex Middle School:
                              400 E Moore St, Apex, NC 27502
                            </Typography>
                              <br />
                            <Typography>
                              邮政信箱为:
                              Raleigh Academy of Chinese Language
                              P O Box 50375
                              Raleigh, NC 27650-6375
                            </Typography>
                              <br />
                              <br />

                            <Typography>
                              Founded in 1995, the Raleigh Academy of Chinese Language (RACL) is a nonprofit, non-political, 501(c)(3) educational institution. Its objectives include promoting Chinese language, teaching Chinese and Oriental history and culture, and enhancing the understanding and friendship among various background people in our community in the Triangle area of North Carolina. RACL strives to reach its goal by conducting school year-long Saturday classes, sponsoring Chinese culture oriented activities, and playing an active and contributing role in our community. Currently there are approximately 500 students enrolled at RACL.
                            </Typography>
                            <br />
                            <Typography>
                              RACL’s classes are conducted regularly at the facility of Apex Middle School in Raleigh from 9:15AM to 1:00PM on Saturdays. RACL offers approximately 35 Chinese language classes tailored to meet the needs of various backgrounds and leveled students in our community. In its language instruction, RACL has adopted the simplified Chinese characters and the “Pinyin” pronunciation system, which are the standard for the billions of Chinese speakers in Mainland China, Southeastern Asia, and many other parts of the world. RACL offers more than 20 sessions of culture and activity classes to enhance students’ learning experiences. Generally, language classes are conducted from 9:15 to 11:00AM, followed by activity sessions from 11:10AM to 1:00PM. Activity classes consist of dancing, drawing, Fun Math, Math SAT, English Writing, Chinese Kung-Fu (Wu-Shu), girls volleyball, soccer, and chess, among others.
                            </Typography>
                              <br />
                            <Typography>
                              RACL also offers Chinese as a Second Language classes to both adult and young students.
                            </Typography>
                              <br />
                            <Typography>
                              We welcome all returning students, new students who have recently reached the age of 4, and those students who have recently moved into the Triangle area.
                            </Typography>
                              <br />
                            <Typography>
                              RACL’s school calendar follows the traditional calendar of the Wake County Public School System.
                            </Typography>
                              <br />
                            <Typography>
                              School Address:  Apex Middle School, 400 E Moore St, Apex, NC 27502
                            </Typography>
                              <br />
                            <Typography>
                              School Mailing Address: Raleigh Academy of Chinese Language, PO Box 50375, Raleigh, NC 27650-6375
                            </Typography>
                        </Box>
                        {/* <Box textAlign={'center'}>
                            <Typography>

                            Founded in 1995, the Raleigh Academy of Chinese Language (RACL) is a nonprofit, non-political, 501(c)(3) educational institution. Its objectives include promoting Chinese language, teaching Chinese and Oriental history and culture, and enhancing the understanding and friendship among various background people in our community in the Triangle area of North Carolina. RACL strives to reach its goal by conducting school year-long Saturday classes, sponsoring Chinese culture oriented activities, and playing an active and contributing role in our community.

                            洛丽汉语学校的新校址位于洛丽市的 Apex Middle School:
                            400 E Moore St, Apex, NC 27502
                            </Typography>
                        </Box> */}

                        </CardContent>
                    </Card>

                    <Card>
                    <CardHeader title='Students Activites'/>
                    <CardContent>
                    <Box textAlign={'center'}>
                            <img src={studentsImage} alt="activity1" style={{ maxWidth: '100%', height: 'auto' }} />
                            
                        </Box>
                        </CardContent>
                    </Card>
                </Grid> 
                <Grid item xs={2} />
            </Grid>

     
    </>
  )
}

export default About